import { ResourceWithIcon } from "@/components/ResourceWithIcon.tsx";
import { DetailsTableRow } from "@/components/table/DetailsTableRow.tsx";
import { vpcLink } from "@/modules/network/links.ts";
import type { VpcWithType } from "@/modules/network/vpc/vpcApi.ts";
import { useLingui } from "@lingui/react/macro";
import { Link } from "@tanstack/react-router";

export function VpcRow({ vpc }: { vpc: VpcWithType | undefined }) {
    const { t } = useLingui();
    return (
        <DetailsTableRow title={t`VPC network`}>
            {vpc ? <ResourceWithIcon type="vpc" title={<Link {...vpcLink(vpc)}>{vpc.name}</Link>} /> : "–"}
        </DetailsTableRow>
    );
}
